import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      maxWidth: "100vw",
    },
  },
  content: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    overflowY: "auto",
    gap: theme.spacing(4),
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      "&::-webkit-scrollbar": {
        width: 0,
      },
    },
  },
  title: {
    fontSize: "3.5rem !important",
    [theme.breakpoints.down("md")]: {
      fontSize: "2.5rem !important",
    },
  },
  button: {
    width: "15em",
  },
}));
